import { Component, input } from '@angular/core';
import { Router } from '@angular/router';
import { Commands } from '../../services/commands/commands';

@Component({
  selector: 'app-end-game',
  imports: [],
  templateUrl: './end-game.html',
  styleUrl: './end-game.css'
})
export class EndGame {

  public points = input<number>(0);
  public passes = input<number>(0);
  public doubles = input<number>(0);

  protected readonly tot_passes = 3;
  protected readonly tot_doubles = 2;

  public playAgain(): void{

    const room_id = this.commands.getRoomId();
    this.router.navigate([`/mind-link/waiting-room/${room_id}`]);

  }

  constructor(
    private router: Router,
    private commands: Commands
  ){}

}
